import { render } from "./EventEdit.vue?vue&type=template&id=73f5dfea&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"

import "./EventEdit.vue?vue&type=style&index=0&id=73f5dfea&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f5dfea"]])

export default __exports__